import { categories } from "@/mocks/homeData";

export default function CategorySection() {
  return (
    <section id="categories" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-3xl">
          <span className="text-xs md:text-sm font-label tracking-[0.2em] text-primary-600 uppercase">
            Content Sections
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            四大内容板块，覆盖看、读、听
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            从高清影视到免费小说，从竖屏漫画到真人听书，四个板块各自独立又互相补充。
            每个板块都按题材与热度整理，进入后可直接浏览当前已收录的条目。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {categories.map((cat) => (
            <article
              key={cat.id}
              className="group rounded-lg border border-background-200 bg-background-100 p-5 md:p-7 transition-colors hover:border-primary-300"
            >
              <div className="flex items-start justify-between gap-4">
                <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center text-2xl md:text-3xl shrink-0">
                  <i className={cat.icon} aria-hidden="true"></i>
                </div>
                <span className="rounded-full bg-secondary-100 text-secondary-900 text-xs px-3 py-1 whitespace-nowrap">
                  {cat.count}
                </span>
              </div>

              <h3 className="mt-5 font-heading text-lg md:text-xl font-bold text-foreground-950">
                {cat.name}
              </h3>
              <p className="mt-1 text-xs md:text-sm text-accent-700 font-medium">{cat.tagline}</p>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{cat.desc}</p>

              <ul className="mt-4 flex flex-wrap gap-2">
                {cat.points.map((p) => (
                  <li
                    key={p}
                    className="inline-flex items-center gap-1 text-xs text-foreground-700 bg-background-50 border border-background-200 rounded-full px-3 py-1"
                  >
                    <i className="ri-check-line text-primary-600" aria-hidden="true"></i>
                    {p}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}